module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.38861cba61c66739c145.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.ttf
// module id = ../../../../primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.ttf
// module chunks = 2